import type { CaptureLogOptions } from "posthog-js";
import { redactCredentialsInText } from "@shared/security/redact-url";
import { redactContactDetails } from "@shared/support/contact-redaction";

const LOG_TEXT_LIMIT = 16_384;
const SENSITIVE_KEY = /password|secret|token|authorization|cookie|api[_-]?key|credential/i;

function redactLogText(value: string): string {
  return redactContactDetails(redactCredentialsInText(value)).replace(/Bearer\s+[^\s"'<>]+/gi, "Bearer <redacted>").replace(/(["']?(?:password|secret|token|cookie|api[_-]?key)["']?\s*[:=]\s*)(["'][^"']*["']|[^\s,;}]+)/gi, "$1<redacted>").slice(0, LOG_TEXT_LIMIT);
}

export function redactBrowserLog(record: CaptureLogOptions, url: string): CaptureLogOptions {
  const attributes = Object.fromEntries(Object.entries(record.attributes ?? {}).map(([key, value]) => {
    if (SENSITIVE_KEY.test(key)) return [redactLogText(key), "<redacted>"];
    if (typeof value === "string") return [redactLogText(key), redactLogText(value)];
    if (typeof value !== "object" || value === null) return [redactLogText(key), value];
    try {
      return [redactLogText(key), redactLogText(JSON.stringify(value, (nestedKey, nestedValue: unknown) => SENSITIVE_KEY.test(nestedKey) ? "<redacted>" : nestedValue))];
    } catch {
      return [redactLogText(key), "<unserializable>"];
    }
  }));
  return { ...record, body: redactLogText(record.body), attributes: { ...attributes, "url.full": redactLogText(url) } };
}
